import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4cc84835&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=4cc84835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc84835",
  null
  
)

export default component.exports
import {QTable,QField,QSpace,QSelect,QInput,QIcon,QTr,QTh,QTd,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCard,QBar,QTooltip,QSeparator,QCardSection,QSpinner,QCardActions,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QField,QSpace,QSelect,QInput,QIcon,QTr,QTh,QTd,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCard,QBar,QTooltip,QSeparator,QCardSection,QSpinner,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
